import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { rtdb } from '../config/firebase';

export default function PresenceBadge({ uid, showLabel = true, style }: { uid: string, showLabel?: boolean, style?: React.CSSProperties }) {
    const [status, setStatus] = useState<'online' | 'offline'>('offline');

    useEffect(() => {
        if (!uid) return;
        const statusRef = ref(rtdb, `/status/${uid}`);
        const unsub = onValue(statusRef, (snap) => {
            const data = snap.val();
            setStatus(data?.state || 'offline');
        });
        return () => unsub();
    }, [uid]);

    if (status === 'online') {
        return <span className="status-badge live" style={{ border: '1px solid var(--success)', color: 'var(--success)', whiteSpace: 'nowrap', ...style }}>🟢 {showLabel ? 'Online' : ''}</span>;
    }
    return <span className="status-badge offline" style={{ opacity: 0.7, whiteSpace: 'nowrap', ...style }}>⚪ {showLabel ? 'Offline' : ''}</span>;
}
